import { SET_DOMAIN_TYPES } from "../actions/types";

const initialState = {
  domainTypesList: [],
};

export default function domainTypesReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_DOMAIN_TYPES: {
      return {
        ...state,
        domainTypesList: action.payload,
      };
    }
    default:
      return state;
  }
}
